import { createStore, applyMiddleware } from 'redux';
import RootReducer from './reducers';
import createSagaMiddleware from 'redux-saga';
import { Sagas } from './sagas';

const sagaMiddleware = createSagaMiddleware();

/**
 * Middleware chain. The action logger is DEVELOPMENT ONLY.
 *
 * It used to be applied unconditionally, which cost every production user a deep
 * traversal of the whole store on every single dispatch — `MsgReducer` alone holds
 * ~60 keys including the entire loaded message history, the saved list and the
 * notification feed, so one inbound socket message serialised all of it to the
 * console on the main thread.
 *
 * It was also a disclosure problem: message bodies and the access token sitting in
 * state were printed to the console of every production browser.
 *
 * `require` rather than a static import so the bundler can drop the module
 * entirely — a top-level `import` of redux-logger stays in the bundle even when
 * nothing reaches it.
 */
const middleware = [sagaMiddleware];

if (process.env.NODE_ENV !== 'production') {
  const { createLogger } = require('redux-logger');
  middleware.unshift(createLogger({ collapsed: true, duration: true }));
}

const Store = createStore(RootReducer, applyMiddleware(...middleware));

sagaMiddleware.run(Sagas);

export default Store;
